<template>
    <div class="maintenance-detail">
        <div class="card border-0 shadow-sm">
            <!-- Header con información principal -->
            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <span class="mb-0 h3">
                    <i class="fas fa-clipboard-check mr-2 me-2"></i>
                    {{ datos.tipoMantenimientoDescripcion }} #{{ datos.mantenimiento_id }}
                </span>
                <span class="badge" :class="datos.estado ? 'bg-success' : 'bg-danger'">
                    {{ datos.estado ? 'Activo' : 'Inactivo' }}
                </span>
            </div>

            <!-- Cuerpo con detalles -->
            <div class="card-body d-flex flex-wrap" style="column-gap: 9vw">
                <!-- Información del vehículo -->
                <div class="mb-4">
                    <span class="border-bottom pb-2 h5 font-weight-bold">
                        <i class="fas fa-truck me-2 pr-2"></i>Información del Vehículo
                    </span>
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <p class="mb-1"><strong>ID:</strong> {{ datos.id }}</p>
                            <p class="mb-0"><strong>Placa:</strong> {{ datos.placa }}</p>
                        </div>
                    </div>
                </div>

                <!-- Información del responsable -->
                <div class="mb-4">
                    <span class="border-bottom pb-2 h5 font-weight-bold">
                        <i class="fas fa-user-tie mr-2 me-2"></i>Información del Responsable
                    </span>
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <p class="mb-1"><strong>Nombre:</strong> {{ datos.nombre_responsable }}</p>
                            <p class="mb-0">
                                <strong>Identificación:</strong>
                                {{ getTipoIdentificacion(datos.tipo_identificacion_responsable) }}
                                {{ datos.numero_identificacion_responsable }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Información del conductor -->
                <div class="mb-4 ">
                    <span class="border-bottom pb-2 h5 font-weight-bold">
                        <i class="fas fa-id-card mr-2 me-2"></i>Información del Conductor
                    </span>
                    <div class="row mt-3">
                        <div class="col-md-6">
                            <p class="mb-1"><strong>Nombre:</strong> {{ datos.nombres_conductor }}</p>
                            <p class="mb-0">
                                <strong>Identificación:</strong>
                                {{ getTipoIdentificacion(datos.tipo_identificacion_conductor) }}
                                {{ datos.numero_identificacion_conductor }}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Detalle de actividades -->
                <div class="mb-4 col-12">
                    <span class="border-bottom pb-2 h5 font-weight-bold">
                        <i class="fas fa-tasks mr-2 me-2"></i>Detalle de Actividades
                    </span>
                    <p class="mt-2 mb-3 fst-italic text-secondary">{{ datos.detalle_actividades }}</p>

                    <div class="table-responsive">
                        <table class="table table-hover">
                            <thead class="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Actividad</th>
                                    <th scope="col" class="text-center">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(actividad, index) in datos.actividades" :key="actividad.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ actividad.nombre }}</td>
                                    <td class="text-center">
                                        <span v-if="actividad.estado" class="text-success">
                                            <i class="fas fa-check-circle"></i>
                                        </span>
                                        <span v-else class="text-danger">
                                            <i class="fas fa-times-circle"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Footer con fechas -->
            <div class="card-footer bg-light">
                <div class="row text-muted small">
                    <div class="col-md-6">
                        <i class="far fa-calendar-plus me-1"></i> Creado: {{ formatDate(datos.created_at) }}
                    </div>
                    <div class="col-md-6 text-md-end">
                        <i class="far fa-calendar-check me-1"></i> Actualizado: {{ formatDate(datos.updated_at) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DetalleMantenimiento",
    props: {
        datos: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return 'N/A';

            const date = new Date(dateString);
            return date.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getTipoIdentificacion(tipo) {
            const tipos = {
                1: 'CC',
                2: 'CE',
                3: 'NIT',
                4: 'Pasaporte'
            };

            return tipos[tipo] || 'Otro';
        }
    }
}
</script>

<style scoped>
.maintenance-detail {
    max-width: 900px;
    margin: 0 auto;
}

.card {
    transition: all 0.3s ease;
}

.card:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.table th,
.table td {
    vertical-align: middle;
}

@media (max-width: 768px) {
    .card-footer .col-md-6:last-child {
        margin-top: 0.5rem;
        text-align: left !important;
    }
}
</style>